import { Permission } from '@lucidtech/las-sdk-browser';

import { AccessLevel, getAccessLevel } from '@/utils';

import { toUserId, useGetUser, useListRoles } from './api';

const matches = (lhs: string, rhs: string) => lhs === rhs || lhs === '*';

export const useGetAccessLevel = () => {
  const { data: user } = useGetUser(toUserId('me'));
  const { data: roles } = useListRoles();

  const userRoles = roles?.data?.filter((role) => user?.roleIds.includes(role.roleId));

  const hasAccessLevel = (accessLevel: AccessLevel, agentId?: string) => {
    const accessLevels = userRoles?.map((role) => getAccessLevel(role.permissions, agentId));
    switch (accessLevel) {
      case AccessLevel.Admin:
        return accessLevels?.some((a) => a === AccessLevel.Admin);
      case AccessLevel.Developer: {
        const requiredAccess: Array<AccessLevel | null> = [AccessLevel.Admin, AccessLevel.Developer];
        return accessLevels?.some((a) => requiredAccess.includes(a));
      }
      case AccessLevel.Reviewer: {
        const requiredAccess: Array<AccessLevel | null> = [
          AccessLevel.Admin,
          AccessLevel.Developer,
          AccessLevel.Reviewer,
        ];
        return accessLevels?.some((a) => requiredAccess.includes(a));
      }
      case null:
        return false;
    }
  };

  const hasPermission = (permission: Permission) => {
    return userRoles?.some((role) =>
      role.permissions.some(
        (p) =>
          matches(p.resourceId, permission.resourceId) &&
          matches(p.action, permission.action) &&
          matches(p.effect, permission.effect)
      )
    );
  };

  return { hasAccessLevel, hasPermission };
};
